import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { Card, Box, AspectRatio, SkeletonCircle, SkeletonText, Flex, Text } from '@hausgold/designsystem';
import { CheckCircled } from '@hausgold/designsystem/icons';
import { kebabCase } from 'lodash-es';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import DynamicIcon from '../../Functional/DynamicIcon.js';
import { jsx } from '@emotion/react';
var _excluded = ["className", "iconId", "iconSvg", "title", "isActive", "isLoading", "children"];
var CustomWizardCard = function CustomWizardCard(_ref) {
  _ref.className;
  var iconId = _ref.iconId,
    iconSvg = _ref.iconSvg,
    title = _ref.title,
    isActive = _ref.isActive,
    isLoading = _ref.isLoading,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx(Card, _extends({
    borderColor: isActive ? 'darkRed.400' : undefined,
    borderRadius: "4px",
    boxShadow: "md",
    className: "wizard-card",
    "data-is-selected": isActive,
    height: "100%",
    position: "relative",
    textAlign: "center",
    transition: "200ms box-shadow",
    wordBreak: "break-word",
    p: {
      base: 2,
      sm: 4
    },
    pb: {
      base: 5,
      sm: 7
    },
    _hover: {
      cursor: 'pointer',
      borderColor: 'darkRed.400'
    }
  }, props), jsx(CheckCircled, {
    boxSize: 4,
    color: "green.400",
    display: !isActive && 'none',
    position: "absolute",
    right: "7%",
    top: "7%"
  }), children || jsx(Fragment, null, jsx(Box, {
    width: {
      base: '75%',
      sm: '100%'
    },
    mx: "auto"
  }, isLoading ? jsx(Box, {
    py: ".5rem"
  }, jsx(AspectRatio, {
    ratio: 1 / 1
  }, jsx(SkeletonCircle, {
    height: "auto",
    speed: 2
  }))) : iconSvg && jsx(DynamicIcon, {
    iconSvg: iconSvg,
    h: "auto",
    w: "100%",
    color: "blue.400",
    mx: "auto",
    className: "wizard-card-icon wizard-card-icon-".concat(kebabCase(iconId))
  }))), (title || isLoading) && jsx(Box, {
    w: "100%",
    my: "auto"
  }, isLoading ? jsx(SkeletonText, {
    endColor: "blue.300",
    noOfLines: 1,
    speed: 2,
    skeletonHeight: "19px",
    px: 8,
    py: "18px" // Quick fix to visually center vertically as Skeleton doesn't work within flex
  }) : jsx(Flex, {
    alignItems: "center",
    justifyContent: "center",
    p: 2,
    mb: 0
  }, jsx(Text, {
    as: "span",
    lineHeight: 1.4,
    color: "gray.400",
    className: "wizard-card-title",
    mb: 0,
    fontWeight: "normal"
  }, title && title))));
};
CustomWizardCard.propTypes = {
  children: PropTypes.node,
  iconId: PropTypes.string,
  iconSvg: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  isActive: PropTypes.bool,
  isLoading: PropTypes.bool,
  className: PropTypes.string
};
CustomWizardCard.defaultProps = {
  children: null,
  iconId: null,
  iconSvg: null,
  title: null,
  isActive: false,
  isLoading: false,
  className: ''
};
export { CustomWizardCard as default };